<template>
  <div v-bind:class="{ 'btn-group secundary': formatSecundary, 'btn-group': !formatSecundary }">
    <li @click="toggleMenu()" v-if="selectedOption.name !== undefined" v-bind:class="{ 'dropdown-toggle color-blue': showMenu, 'dropdown-toggle': !showMenu }">
      <!-- {{ selectedOption.name }} -->
      {{ formatSecundary ? selectedOption.name : placeholderText  }}
      &nbsp;
      <!-- <span class="caret"></span> -->

      <svg
        v-if="showMenu"
        width="12"
        height="8"
        viewBox="0 0 12 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.59 7.40991L6 2.82991L1.41 7.40991L1.23266e-07 5.99991L6 -8.82626e-05L12 5.99991L10.59 7.40991Z"
          fill="#0080FC"
        />
      </svg>
      <svg
        v-else
        width="12"
        height="8"
        viewBox="0 0 12 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.41 0.589966L6 5.16997L10.59 0.589966L12 1.99997L6 7.99997L0 1.99997L1.41 0.589966Z"
          fill="black"
        />
      </svg>
    </li>

    <li @click="toggleMenu()" class="dropdown-toggle" v-if="selectedOption.name === undefined" v-bind:class="{ 'dropdown-toggle color-blue': showMenu, 'dropdown-toggle': !showMenu }">
      {{placeholderText}}
      <!-- <span class="caret"></span> -->
       <svg
        v-if="showMenu"
        width="12"
        height="8"
        viewBox="0 0 12 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.59 7.40991L6 2.82991L1.41 7.40991L1.23266e-07 5.99991L6 -8.82626e-05L12 5.99991L10.59 7.40991Z"
          fill="#0080FC"
        />
      </svg>
      <svg
        v-else
        width="12"
        height="8"
        viewBox="0 0 12 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.41 0.589966L6 5.16997L10.59 0.589966L12 1.99997L6 7.99997L0 1.99997L1.41 0.589966Z"
          fill="black"
        />
      </svg>
    </li>
    <transition name="fade">
      <ul class="dropdown-menu-int" v-if="showMenu">
        <li v-for="(option, idx) in options" :key="idx">
          <a href="javascript:void(0)" @click="updateOption(option)" v-bind:class="{ 'sel-selected': selectedOption.name == option.name, 'wow': selectedOption.name  === undefined }">{{ option.name }}</a>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedOption: {
        name: "",
      },
      showMenu: false,
      placeholderText: "Please select an item",
    };
  },
  props: {
    options: {
      type: [Array, Object],
    },
    selected: {},
    placeholder: [String],
    closeOnOutsideClick: {
      type: [Boolean],
      default: true,
    },
    formatSecundary: [Boolean]
  },

  mounted() {
    this.selectedOption = this.selected;
    if (this.placeholder) {
      this.placeholderText = this.placeholder;
    }

    if (this.closeOnOutsideClick) {
      document.addEventListener("click", this.clickHandler);
    }
    // if (this.formatSecundary) {
    //   console.log(this);
    // }
  },

  beforeDestroy() {
    document.removeEventListener("click", this.clickHandler);
  },

  methods: {
    updateOption(option) {
      this.selectedOption = option;
      this.showMenu = false;
      this.$emit("updateOption", this.selectedOption);
    },

    toggleMenu() {
      this.showMenu = !this.showMenu;
    },

    clickHandler(event) {
      const { target } = event;
      const { $el } = this;

      if (!$el.contains(target)) {
        this.showMenu = false;
      }
    },
  },
};
</script>

<style>
.btn-group {
  min-width: 160px;
  height: 40px;
  position: relative;
  display: inline-block;
  vertical-align: middle;
  background: white;
}
.btn-group a:hover {
  text-decoration: none;
}

.dropdown-toggle {
  text-align: center;
  color: #434343;
  min-width: 160px;
  height: 40px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 10px 20px 10px 10px;
  text-transform: none;
  font-weight: 300;
  font-size: 12px;
  border: 0;
  background-size: 0 2px, 100% 1px;
  background-repeat: no-repeat;
  background-position: center bottom, center calc(100% - 1px);
  background-color: transparent;
  transition: background 0s ease-out;
  float: none;
  box-shadow: none;
  border-radius: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-family: "Muli-Regular";
  font-weight: 700;
}
.dropdown-toggle:hover {
  /* color: #0080fc; */
  cursor: pointer;
}
.color-blue {
    color: #0080fc;
}
.btn-group.secundary {
  background: transparent;
} 
.btn-group.secundary .dropdown-toggle {
  font-size: 1.4rem;
  color: #000000;
}
.dropdown-menu-int {
  position: absolute;
  top: 70px;
  left: 0;
  z-index: 1000;
  float: left;
  min-width: 160px;
  padding: 5px 0;
  margin: 2px 0 0;
  list-style: none;
  font-size: 14px;
  text-align: left;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-clip: padding-box;
}
.dropdown-menu-int::before {
    content: close-quote;
    position: absolute;
    width: 0;
    height: 0;
    margin-left: 1.5em;
    top: .1em;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: .95em solid #000;
    border-color: transparent transparent #fff #fff;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: rotate(135deg);
    transform: rotate(135deg);
    left: 50%;  
}

.dropdown-menu-int > li > a {
  padding: 10px 30px;
  display: block;
  clear: both;
  font-weight: 700;
  line-height: 1.6;
  color: #333333;
  white-space: nowrap;
  text-decoration: none;
}
.dropdown-menu-int > li > a:hover,
.dropdown-menu-int > li > a.sel-selected {
  background: #efefef;
  color: #0080fc;
}

.dropdown-menu-int > li {
  overflow: hidden;
  width: 100%;
  position: relative;
  margin: 0;
}

.caret {
  width: 0;
  position: absolute;
  top: 19px;
  height: 0;
  margin-left: -24px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid \9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  right: 10px;
}

li {
  list-style: none;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.7s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/super-checkout-intern/dropdown.vue